import { Line } from 'react-chartjs-2'

import {
  CategoryScale,
  Chart as ChartJS,
  ChartOptions,
  Filler,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  Tooltip
} from 'chart.js'

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip, Legend)

// 左軸（件数）の配色 / 右軸（スコア）= 柿色
const LEFT_COLORS = ['#1592d1', '#0A8E7C']
const RIGHT_COLOR = '#FFB800'

interface Props {
  labels: string[]
  // 左Y軸の折れ線（件数など）
  countLines: { title: string; values: number[] }[]
  // 右Y軸の折れ線（0〜100のスコア）
  scoreLine: { title: string; values: number[] }
  showLegend?: boolean
}

const DualAxisLineChart = ({ labels, countLines, scoreLine, showLegend = true }: Props) => {
  const options: ChartOptions<'line'> = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: 'index', intersect: false },
    plugins: {
      legend: {
        display: showLegend,
        position: 'top',
        align: 'end',
        labels: {
          color: '#34414F',
          font: { size: 12 },
          boxWidth: 24,
          boxHeight: 2,
          padding: 8,
          usePointStyle: false
        }
      },
      tooltip: {
        backgroundColor: 'rgba(2, 6, 23, 0.95)',
        titleFont: { family: "'JetBrains Mono', monospace", size: 11, weight: 'bold' },
        bodyFont: { family: "'JetBrains Mono', monospace", size: 11 },
        padding: 8,
        cornerRadius: 4,
        displayColors: true,
        callbacks: {
          label: (ctx) => {
            const value = ctx.parsed.y ?? 0
            return ctx.dataset.yAxisID === 'y1'
              ? `${ctx.dataset.label}: ${value}`
              : `${ctx.dataset.label}: ${value.toLocaleString()}`
          }
        }
      }
    },
    scales: {
      x: {
        grid: { display: false },
        border: { display: false },
        ticks: { font: { size: 10 }, color: '#34414F', maxRotation: 0 }
      },
      y: {
        beginAtZero: true,
        border: { display: false },
        grid: { color: '#E4E8EE' },
        ticks: { font: { size: 10 }, color: '#34414F', padding: 6, count: 6 }
      },
      y1: {
        type: 'linear',
        position: 'right',
        beginAtZero: true,
        max: 100,
        border: { display: false },
        grid: { drawOnChartArea: false },
        ticks: { font: { size: 10 }, color: '#34414F', padding: 6, count: 6 }
      }
    },
    elements: {
      line: { borderWidth: 2.5, tension: 0 },
      point: { radius: 0, hoverRadius: 4, hitRadius: 8 }
    }
  }

  return (
    <Line
      data={{
        labels,
        datasets: [
          ...countLines.map((item, i) => ({
            label: item.title,
            data: item.values,
            borderColor: LEFT_COLORS[i % LEFT_COLORS.length],
            backgroundColor: LEFT_COLORS[i % LEFT_COLORS.length],
            fill: false,
            spanGaps: true,
            yAxisID: 'y'
          })),
          {
            label: scoreLine.title,
            data: scoreLine.values,
            borderColor: RIGHT_COLOR,
            backgroundColor: RIGHT_COLOR,
            fill: false,
            spanGaps: true,
            yAxisID: 'y1'
          }
        ]
      }}
      options={options}
    />
  )
}

export default DualAxisLineChart
